
// Format date/time for display
export const formatDate = (date: string | Date | undefined): string => {
  
  if (!date) return 'N/A';

  // Check if input is a string or date
  if (typeof date === 'string') {
    date = new Date(date);
  } else if (!(date instanceof Date)) {
    return 'Invalid Date';
  }
  
  return date.toLocaleDateString('en-US', {
    year: 'numeric',
    month: '2-digit',
    day: '2-digit',
    hour: '2-digit',
    minute: '2-digit'
  });
};
